import useLocalization from '@app/hooks/useLocalization'
import { IFoodPreparingPlaces } from '@app/interfaces/organization-passport/food-preparing-places'
import { sortByName } from '@app/utils/sort-by-name/sort-by-name'
import { Form, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface props {
  foodPreparingPlaces: IFoodPreparingPlaces[]
}

const FoodPreparingPlacesItem: React.FC<props> = ({ foodPreparingPlaces }) => {
  const [t] = useTranslation()
  const { localize } = useLocalization()

  return (
    <>
      <Form.Item
        label={t('foodPreparingPlace.foodPreparingPlace')}
        name={'foodPreparingPlace'}
      >
        <Select>
          {sortByName(localize(foodPreparingPlaces)).map(
            (foodPreparingPlaces, index) => {
              if (foodPreparingPlaces.status) {
                return (
                  <Select.Option
                    key={index}
                    value={foodPreparingPlaces.id!.toString()}
                  >
                    {foodPreparingPlaces?.data?.name}
                  </Select.Option>
                )
              }
              return null
            },
          )}
        </Select>
      </Form.Item>
    </>
  )
}

export default FoodPreparingPlacesItem
